import { render, staticRenderFns } from "./CreatedOrEditedCompany.vue?vue&type=template&id=b2d10e08&scoped=true&"
import script from "./CreatedOrEditedCompany.vue?vue&type=script&lang=js&"
export * from "./CreatedOrEditedCompany.vue?vue&type=script&lang=js&"
import style0 from "./CreatedOrEditedCompany.vue?vue&type=style&index=0&id=b2d10e08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d10e08",
  null
  
)

export default component.exports